import { roundPoint } from './number';

function createCurve(x1: number, y1: number, x2: number, y2: number): string {
    const midX = roundPoint((x2 + x1) / 2);
    return ` C${midX},${y1} ${midX},${y2} ${x2},${y2}`;
}

function createVerticalCurve(x1: number, y1: number, x2: number, y2: number): string {
    const midY = roundPoint((y2 + y1) / 2);
    return ` C${x1},${midY} ${x2},${midY} ${x2},${y2}`;
}

/**
 * A funnel segment is drawn clockwise: 1->2 curved, 2->3 straight down (via the
 * final point), 3->4 curved backwards (using YNext), then closed back to 1.
 */
export function createPath(X: number[], Y: number[], YNext: number[]): string {
    let d = `M${X[0]},${Y[0]}`;

    for (let i = 0; i < X.length - 1; i++) {
        d += createCurve(X[i], Y[i], X[i + 1], Y[i + 1]);
    }

    d += ` L${X[X.length - 1]},${YNext[YNext.length - 1]}`;

    for (let i = X.length - 1; i > 0; i--) {
        d += createCurve(X[i], YNext[i], X[i - 1], YNext[i - 1]);
    }

    d += ' Z';
    return d;
}

/** Vertical funnels are drawn counter-clockwise: 1->2 down, 2->3 across, 3->4 up (via XNext), then closed. */
export function createVerticalPath(X: number[], XNext: number[], Y: number[]): string {
    let d = `M${X[0]},${Y[0]}`;

    for (let i = 0; i < X.length - 1; i++) {
        d += createVerticalCurve(X[i], Y[i], X[i + 1], Y[i + 1]);
    }

    d += ` L${XNext[XNext.length - 1]},${Y[Y.length - 1]}`;

    for (let i = X.length - 1; i > 0; i--) {
        d += createVerticalCurve(XNext[i], Y[i], XNext[i - 1], Y[i - 1]);
    }

    d += ' Z';
    return d;
}
